module.exports = __webpack_public_path__ + "static/media/s-3 57.6x280.112a00c0.jpg";